import React, { useState, useEffect, useRef } from "react";
import { getUserProducts } from "../auth/apiProduct";
import { isAuthenticated } from "../auth";
import Card from "./Card";
import ButtonPagination from "./ButtonPagination";
import ProductGridShop from "./ProductGridShop.jsx";
import elakayEmptyBox from "../Layout/icon/elakayEmptyBox.png";
import SearchBar from "./admin_associate_searchBar";
import FilterUserProduct from "./filterUserProduct";
import Modal from "react-bootstrap/Modal";
import useDebouncedValue from "./hooks/useDebouncedValue";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["productGridEdit"]?.[key] || fallback;

const initialFilterUserProd = {
    asc: "asc",
    unpublished: false,
    dropshipping: false,
    limit: 12,
    sortBy: "createdAt",
    search: "",
};

const ProductGridEdit = ({
    laguangeElakay,
    infoSource,
    promoMaker = false,
    edit,
    btnShopPromo,
    refShopName,
}) => {
    __setElakayInfoSource(infoSource);
    const { token } = isAuthenticated();
    const [productsByArrival, setProductsByArrival] = useState([]);
    const [skip, setSkip] = useState(0);
    const [size, setSize] = useState(0);
    const [siseProduct, setSiseProduct] = useState(0);
    const [getCategoriesUser, setCategoriesUser] = useState([]);
    const [showFilterOurTeam, setSowFilterOurTeam] = useState(false);
    const [getFilterUserProd, setFilterUserProd] = useState(initialFilterUserProd);
    const [myFilters, setMyFilters] = useState({ filters: { "categoriesID.gategoriesLink": [] } });
    const divCatProduct = useRef(null);

    const { asc, limit, unpublished, dropshipping, sortBy, search } = getFilterUserProd;
    // Même filtre (recherche + catégories + tri) que userProduct.js/showAllProduct
    // -- seule la recherche est débounced ici, un ajout sûr par rapport à
    // l'original qui ne débounce rien du tout.
    const debouncedSearch = useDebouncedValue(search, 300);
    const filterUrl = { search: debouncedSearch || undefined };

    const scrollToParagraph = (ref) => {
        if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    const fetchProducts = (toSkip) => {
        getUserProducts(token, toSkip, limit, getFilterUserProd, 3, filterUrl, myFilters.filters).then((data) => {
            if (!data || data.error) return;
            setProductsByArrival(data.products || []);
            setSiseProduct(data.siseProduct || 0);
            setSize(data.size || 0);
            setSkip(toSkip);
            getCategoriesUser?.length === 0 && setCategoriesUser(data.categories || []);
        });
    };

    useEffect(() => {
        fetchProducts(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, myFilters, sortBy, asc, unpublished, dropshipping, limit, debouncedSearch]);

    const loadMore = () => {
        scrollToParagraph(divCatProduct);
        fetchProducts(skip + limit);
    };

    const loadMore0 = () => {
        scrollToParagraph(divCatProduct);
        fetchProducts(skip - limit);
    };

    // FilterUserProduct.jsx appelle loadProductsByArrival(token, DealProduct,
    // myFilters, getFilterUserProd) (même signature que userProduct.js) --
    // mais fetchProducts lit déjà tout depuis le state du closure, donc ce
    // wrapper ignore ces arguments et se contente de relancer à la page 0.
    const loadProductsByArrival = () => fetchProducts(0);

    const handleFilters = (filters, filterBy) => {
        setMyFilters({ ...myFilters, filters: { ...myFilters.filters, [filterBy]: filters } });
    };

    const propsFIlter = {
        getCategoriesUser,
        getFilterUserProd,
        setFilterUserProd,
        handleFilters,
        setMyFilters,
        myFilters,
        setSowFilterOurTeam,
        infoFil: { token, DealProduct: 3 },
        loadProductsByArrival,
        showProdTable: false,
    };

    const filterCategory = () => (
        <div className="row mt-4 mb-4 justify-content-center">
            <div className="col col-12 col-md-10 col-lg-8 col-xl-6">
                <SearchBar
                    infoSource={infoSource}
                    getFilterUserProd={getFilterUserProd}
                    setFilterUserProd={setFilterUserProd}
                    setSowFilterOurTeam={setSowFilterOurTeam}
                    Shop={true}
                    productShowAll={false}
                />
            </div>
        </div>
    );

    const filterOurTeam = () => (
        <Modal
            size="md"
            show={showFilterOurTeam}
            onHide={() => setSowFilterOurTeam(false)}
            aria-labelledby="product-grid-edit-filter-modal"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="product-grid-edit-filter-modal">
                    <h2>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).userProduct.t002}</h2>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FilterUserProduct infoSource={infoSource} {...propsFIlter} />
            </Modal.Body>
        </Modal>
    );

    return (
        <>
            {filterCategory()}
            {filterOurTeam()}
            <ProductGridShop
                divCatProduct={divCatProduct}
                productsByArrival={productsByArrival}
                skip={skip}
                limit={limit}
                siseProduct={siseProduct}
                size={size}
                prodCat={infoSource.laguangeElakay("headNenu", infoSource.languageAPI).myShop || __elakayText("t001", "My Shop")}
                infoSource={infoSource}
                laguangeElakay={laguangeElakay}
                Card={Card}
                promoMaker={promoMaker}
                btnShopPromo={btnShopPromo}
                refShopName={refShopName}
                ButtonPagination={ButtonPagination}
                loadMore={loadMore}
                loadMore0={loadMore0}
                elakayEmptyBox={elakayEmptyBox}
                 edit={edit}
            />
        </>
    );
};

export default ProductGridEdit;
